// apps/client/src/characters/look.ts (M0-T16; M2-T11 adds villagerToDoll) — profile Look → DollSpec (§8.5)
import { friendColors, look, type FriendColor } from '@whiskerton/content';
import type { Look, VillagerPublic } from '@whiskerton/shared';
import type { DollSpec } from './doll';

export const DEFAULT_LOOK: Look = { skin: 'skin2', eyes: 'round', hairStyle: 'short', hairColor: 'brown', shirt: 'friend', pants: 'denim', shoes: 'brown' };
const hex = (list: readonly { id: string; hex: string }[], id: string, fallback: string) => list.find((o) => o.id === id)?.hex ?? fallback;
const fallbackHex = (list: readonly { hex: string }[]) => list[0]?.hex ?? '#FFFFFF';
/** Resolves swatch ids to colours; `shirt: 'friend'` wears the town friend colour (D-21), and every look wears that colour's tag shade as
 *  its accent (the collar, a bun's tie; characters pass 2026-10-16). Unknown ids fall back to a default swatch. */
export function lookToDoll(l: Look, friend: FriendColor): DollSpec {
  const dye = (id: string) => (id === 'friend' ? friendColors[friend].dye : hex(look.dyes, id, fallbackHex(look.dyes)));
  return { kind: 'person', skin: hex(look.skins, l.skin, fallbackHex(look.skins)), eyes: l.eyes, hair: hex(look.hairColors, l.hairColor, fallbackHex(look.hairColors)),
    hairStyle: l.hairStyle, shirt: dye(l.shirt), pants: dye(l.pants), shoes: dye(l.shoes), accent: friendColors[friend].tag };
}
export { isValidLook } from '@whiskerton/shared/rules/look';   // contract change 26: the shared validator, not a copy

/** A villager's species and colours as a doll (§8.5). `pants` is the fur colour so legs read as fur; sheep keep a dark face and
 *  hooves (the ears colour) with wool in the fur colour; a duck's feet match its bill (the muzzle colour). */
export function villagerToDoll(v: VillagerPublic): DollSpec {
  const c = v.colors;
  const sheep = v.species === 'sheep';
  return { kind: v.species, skin: sheep ? c.ears : c.fur, hair: sheep ? c.fur : undefined, ears: c.ears, muzzle: c.muzzle,
    shirt: c.shirt, pants: c.fur, shoes: v.species === 'duck' ? c.muzzle : c.ears, pattern: c.pattern, patternColor: c.patternColor };
}
